import { buildUserScopedCacheKey } from "../utils/class-utils";

const storageKey = "forgotten-system-alerts";
const getStorageKey = () => buildUserScopedCacheKey(storageKey);

const getForgottenFromStorage = () => {
  const storage = window.sessionStorage;
  storage.removeItem(storageKey);
  const forgottenJson = storage.getItem(getStorageKey());

  if (!forgottenJson) {
    return [];
  }
  let forgotten = [];
  try {
    forgotten = JSON.parse(forgottenJson);
  } catch (e) {
    forgotten = [];
  }
  return forgotten;
};

const alertSessionMemory = {
  forgotten: getForgottenFromStorage,
  forget: (alert) => {
    const storage = window.sessionStorage;
    if (!alert || !alert.id) {
      return;
    }
    const forgotten = getForgottenFromStorage();
    forgotten.push(alert.id);
    storage.setItem(getStorageKey(), JSON.stringify([...forgotten]));
    storage.removeItem(storageKey);
  },
  filter: (alerts) => {
    const forgottenIds = getForgottenFromStorage();
    return alerts.filter((a) => {
      const match = forgottenIds.find((id) => a.id === id);
      return !match;
    });
  },
  clear: () => {
    const storage = window.sessionStorage;
    storage.setItem(getStorageKey(), JSON.stringify([]));
    storage.removeItem(storageKey);
  },
};
export default alertSessionMemory;
